import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        productImage: {
            boxSize: {base: remCalc(109), lg: remCalc(212)},
            paddingBottom: remCalc(24),
        },
        productDetails: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: {base: remCalc(16), lg: remCalc(26)},
            borderBottom: 'small',
            borderColor: 'border.light',
            width: '100%',
            minWidth: ['unset', 'unset', 'unset', remCalc(476)],
            maxWidth: {base: 'unset', lg: remCalc(688)},
        },
        productdGrid: {
            display: {base: 'flex', lg: 'grid'},
            flexDirection: {base: 'column', lg: 'unset'},
            templateColumns: 'repeat(2, 1fr)',
            gap: {base: remCalc(40), lg: `${remCalc(40)} ${remCalc(24)}`},
            width: '100%',
        },
        productButton: {
            display: 'flex',
            height: remCalc(33),
            minWidth: remCalc(140),
            width: remCalc(140),
            maxHeight: remCalc(40),
            padding: `${remCalc(18)} ${remCalc(24)}`,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: remCalc(100),
            border: null,
            borderColor: 'dark',
            borderStyle: 'solid',
            background: 'button.background.primary-default',
            marginBottom: {base: remCalc(24), lg: remCalc(0)},
        },
        buttonText: {
            textStyle: 'body-medium',
            fontWeight: '700',
            color: 'button.text.primary-default',
        },
        productLabels: {
            gap: {base: remCalc(8), lg: remCalc(16)},
        },
        productTitle: {
            textStyle: 'head-xsmall',
            fontWeight: '500',
            color: 'text.default',
        },
        productDescription: {
            textStyle: 'body-small',
            fontWeight: '400',
            color: 'text.default',
        },
    },
    variants: {
        doubleProducts: {
            productDetails: {
                maxWidth: 'unset',
            },
            productdGrid: {
                display: 'flex',
                flexDirection: 'column',
            },
        },
        singleProduct: {
            productDetails: {
                maxWidth: 'unset',
                borderBottom: 'none',
            },
            productdGrid: {
                display: 'flex',
                flexDirection: 'column',
            },
            productButton: {
                marginBottom: 0,
            },
        },
    },
}
